module.exports = __webpack_public_path__ + "img/Illustration 1.54506933.svg";